import { useVersionCheck } from "./useVersionCheck";

interface VersionCheckNotifyProps {
  // status: string;
}

export const VersionCheckNotify: React.FC<VersionCheckNotifyProps> = ({  }) => {
  const { dismiss, snooze, status, currentVersion, remoteVersion } = useVersionCheck();
  const visible = status === "updateAvailable";

  console.log("UpdateNotify render: status=", status, "remoteVersion=", remoteVersion, "visible=", visible);
  return (
    /* slide-down wrapper – height animates between 0 and auto via max-h */
    <div
      className="fixed top-0 left-0 right-0 z-9999 overflow-hidden"
      style={{
        maxHeight: visible ? "120px" : "0px",
        transition: "max-height 380ms cubic-bezier(.4,0,.2,1)",
      }}
    >
      <div className="bg-white border-b border-amber-300 shadow-md px-4 py-3">
        <div className="max-w-4xl mx-auto flex items-start gap-3">
          {/* icon blob */}
          <div className="shrink-0 w-9 h-9 rounded-full bg-amber-100 flex items-center justify-center mt-0.5">
            <svg className="text-amber-600" width="18" height="18" viewBox="0 0 20 20" fill="none">
              <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="2" />
              <path d="M10 5v5l3 3" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </div>

          {/* text */}
          <div className="flex-1 min-w-0">
            <p className="text-sm font-semibold text-gray-800">
              A new version is available
              <span className="ml-2 text-xs font-normal text-gray-500">{currentVersion} → {remoteVersion}</span>
            </p>
            <p className="text-xs text-gray-500 mt-0.5">
              Refresh to get the latest features, bug fixes and performance improvements.
            </p>
          </div>

          {/* actions */}
          <div className="flex items-center gap-2 shrink-0">
            <button
              onClick={() => window.location.reload()}
              className="text-xs font-semibold px-3 py-1.5 rounded-lg transition-colors shadow-sm bg-amber-500 hover:bg-amber-600 text-white"
            >
              Refresh now
            </button>
            <button
              onClick={snooze}
              className="text-xs font-medium px-3 py-1.5 rounded-lg transition-colors bg-gray-100 hover:bg-gray-200 text-gray-600"
            >
              Later
            </button>
            <button
              onClick={dismiss}
              className="text-gray-400 hover:text-gray-600 transition-colors"
              title="Dismiss permanently"
            >
              <svg width="14" height="14" viewBox="0 0 14 14" fill="none">
                <path d="M2 2l10 10M12 2L2 12" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
              </svg>
            </button>
          </div>
        </div>
      </div>
    </div>
  );

};